import Vue from 'vue'
import MessageTip from './message.vue'
const msgPage = Vue.extend(MessageTip);

let Message = (option) => {
  const section = document.createElement('section');
  document.body.appendChild(section);
  let op = {
    msgItem:{},
    tipid:'tipTop_' + Math.random()
  };
  if(isString(option)) {
    op.msgItem['message'] = option
  }else if(isObject(option)){
    // 兼容 Element UI 风格的调用: { message: 'xxx', type: 'Error' }
    if(option.message || option.type){
      op.msgItem = {
        message: option.message || '',
        type: option.type || 'Prompt',
        dangerouslyUseHTMLString: option.dangerouslyUseHTMLString || false
      }
      // 保留其他配置项
      if(option.timeout) op.timeout = option.timeout
    } else if(option.msgItem){
      // 兼容原有的 msgItem 风格调用
      op = {...op, ...option}
    }
  }
  option = {...op}
  const propsData = Object.assign({},option);
  const mytip = new msgPage({
    propsData,
  }).$mount(section);
  mytip.topTipWrongShow();
  let timeout = op['timeout'] || 3500;
  setTimeout(() => {
    mytip.topTipWrongHidden();
  },timeout)
}

// 添加error、success等方法
Message.error = function(message) {
  return Message({
    msgItem: {
      message: message,
      type: 'Error'
    }
  });
};

Message.success = function(message) {
  return Message({
    msgItem: {
      message: message,
      type: 'Success'
    }
  });
};

Message.warning = function(message) {
  return Message({
    msgItem: {
      message: message,
      type: 'Warning'
    }
  });
};

function isString(str){//判断是否为字符串
  return (typeof str==='string') && str.constructor===String;
}
function isObject(obj){//判断是否为对象
  return (typeof obj==='object') && obj.constructor===Object;
}
export { Message }



// WEBPACK FOOTER //
// ./src/components/message/message.js